<app-mat-spinner-overlay *ngIf="showWaitingForDataSpinner" [overlay]="true"></app-mat-spinner-overlay>

<div class="ktbl-main-container">
  <app-header class="ktbl-app-header"></app-header>

  <main class="ktbl-app-content">
    <router-outlet></router-outlet>
  </main>

  <app-footer class="ktbl-app-footer"></app-footer>
</div>